'use client';

import dynamic from 'next/dynamic';
import { useEffect } from 'react';

const Agentation = dynamic(() => import('agentation').then((mod) => mod.Agentation), {
  ssr: false,
});

export default function AgentationBridge() {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') {
      return;
    }

    document.documentElement.dataset.agentationEnabled = 'true';

    return () => {
      delete document.documentElement.dataset.agentationEnabled;
    };
  }, []);

  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  return (
    <Agentation
      endpoint={process.env.NEXT_PUBLIC_AGENTATION_ENDPOINT || 'http://localhost:4747'}
      className="agentation-toolbar"
    />
  );
}
